// extracted by mini-css-extract-plugin
module.exports = {"container":"container__3-xsB","frame":"frame___alLk","text":"text__2SiS-"};